<template>
  <div class="exr-item">
    <el-input v-model="value.translation" placeholder="翻译" :readonly="readonly"></el-input>
  </div>
</template>

<script>
export default {
  name: "PdtItemTranslation",
  props: {
    value: Object,
    readonly: Boolean
  },
}
</script>